module.exports = __webpack_public_path__ + "img/medicase.e90820e0.jpg";